import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'contaspagar', ptBr);
i18next.addResourceBundle('en', 'contaspagar', en);

const FornecedorConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/financeiro/conta-pagar',
      component: React.lazy(() => import('./ContasPagar')),
    },
  ],
};

export default FornecedorConfig;
